/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Icsrm_Introspektive18Inputs */

const en__field_enum_icsrm_introspektive18 = /** @type {(inputs: _Field_Enum_Icsrm_Introspektive18Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get to know your own stregths and weakness better`)
};

const de__field_enum_icsrm_introspektive18 = /** @type {(inputs: _Field_Enum_Icsrm_Introspektive18Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Persönliche Stärken und Schwächen erkennen`)
};

/**
* | output |
* | --- |
* | "Get to know your own stregths and weakness better" |
*
* @param {_Field_Enum_Icsrm_Introspektive18Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_icsrm_introspektive18 = /** @type {((inputs?: _Field_Enum_Icsrm_Introspektive18Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Icsrm_Introspektive18Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_icsrm_introspektive18(inputs)
	return de__field_enum_icsrm_introspektive18(inputs)
});
export { _field_enum_icsrm_introspektive18 as "_field_enum_ICSRM_INTROSPEKTIVE" }